import { render, staticRenderFns } from "./FormSanPham.vue?vue&type=template&id=55d05df2&scoped=true&"
import script from "./FormSanPham.vue?vue&type=script&lang=js&"
export * from "./FormSanPham.vue?vue&type=script&lang=js&"
import style0 from "./FormSanPham.vue?vue&type=style&index=0&id=55d05df2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d05df2",
  null
  
)

export default component.exports